const fr = {
  navbar: {
    about: "Á propos",
    content: "Contenu éducatif",
    features: "Caractéristiques d’app",
    trust: "Avis",
    contact: "Nous-Contacts",
    parent: "Es Parents",
  },

  header: {
    lines: [
      "L'application Khotoua est le compagnon idéal pour les enfants",
      "du primaire qui veulent améliorer leur expérience éducative d'une",
      "manière amusante et intéressante.",
      "Une application préparée par des experts pédagogiques à la lumière",
      "des programmes scolaires et des meilleures méthodes et approches",
      "éducatives contemporaines."
     
    ],
    download: "Téléchargez L'app",
  },

  about: {
  title: "Á propos",
  lines: [
    "Khotoua : C'est une application éducative révolutionnaire qui réinvente l'apprentissage primaire des enfants à partir d’âge de 5 à 12 ans.",
    "En intégrant la réalité augmentée et l'intelligence artificielle, il offre une expérience immersive et une interaction unique. Scénarios remplis de jeu 2D/3D.",
    "Conçu pour stimuler les compétences cognitives d'une manière divertissante et créative, et améliorer l'apprentissage Personnel."
  ],
},

educational: {
    title: 'Contenu éducatif',
    items: [
      'Jeux éducatifs',
      'Réalité augmentée',
      'Laboratoire scientifique',
      'Compétences de vie',
      'Arts de la conversation',
      'Vidéos et histoires utiles',
    ],
  },

  features: {
    sectionTitle: {
      first: 'Caréctéristiques',
      second: 'd’app',
    },
    steps: [
      'Contenu compatible avec le programme',
      'Surmonter les difficultés',
      'Réalité augmentée',
      'La Pyramide de bloom',
      'Ce que l’application offre aux parents',
    ],
    heading: 'Contenu compatible avec le programme',
    paragraphs: [
      'Dans l’application "Khotoua", nous sommes désireux de faire',
      'correspondre tous les sujets fournis avec les programmes officiels de',
      'l’étape primaire et lorsqu’ils les dépassent, afin de les attribue et',
      '.l’enrichir et élargir son contenu',
      'Notre équipe professionnelle d’audit pédagogique et à plusieurs',
      'niveaux a assuré une bonne préparation des activités éducatives et des',
      'jeux éducatifs basés sur le programme d’études et des approches',
      '.officielles',
    ],
  },


  teacher: {
    title: "Avis", 
    subtitle: "Les enseignants",
    downloadTitleAlt: "Image titre 'وثقوا بنا'",
    testimonials: [
      {
        name: "Nawwi Eya",
        title: "Instituteur",
        comment:
        "Amusez-vous et apprenez lors d'un voyage unique pour explorer le monde d'une manière passionnante et divertissante. Il s'agit de l'application Khatwa, l'innovateur tunisien qui combine jeux et apprentissage en un seul... pour renforcer les concepts éducatifs avec des évaluations individuelles et des rapports de développement. Félicitations!"
      },
      {
        name: "Jervel Nejm Eddin",
        title: "Enseignant d'école primaire à la retraite, distingué et de rang supérieur",
        comment:
        "C’est une étape solide vers l’avancement de l’apprenant vers l’excellence, la construction de ses connaissances sur des bases solides et l’élévation vers le meilleur. Il apprend dans une atmosphère de plaisir, en s'appuyant sur les exercices qui lui sont proposés, qui visent à améliorer ses acquisitions d'une manière merveilleuse qui le conduit à l'excellence."
      },
      {
        name: "Rayess Habiba",
        title: "Professeur d'arabe pour débutants",
        comment: "À l’ère de la technologie, deux étapes sont nécessaires : une étape vers la connaissance, une étape vers la technologie et une étape vers la mise en œuvre.",
      },
      {
        name: "Ziraoui Mohammed",
        title: "Professeur d'arabe pour débutants",
        comment:
        "Il s’agit de capsules pédagogiques modernes et innovantes, compatibles avec les programmes officiels et qui répondent aux intelligences et aux styles d’apprentissage distinctifs de chaque apprenant. Ils abordent les difficultés et développent les compétences et les capacités de létudiant avec facilité d'utilisation."
      },
      {
        name: "Hbibi Selma",
        title: "Enseignant principal au-dessus du rang des écoles primaires",
        comment: "Chaque début a un premier pas. Appliquer l’étape sera le premier pas vers l’excellence.",
      },
    ],
    images: {
      topCloudsAlt: "Nuages en haut",
      bottomDecorAlt: "Nuages en bas",
      lampeAlt: "Image de lampe",
      staraloneAlt: "Décoration étoile",
      notebookAlt: "Décoration carnet",
      astroAlt: "Décoration astronaute",
    },
  },

  contact: {
    sectionTitle: { first: 'Contact', second: 'nous' },
    cards: [
      { title: 'Service client', line: '078 078 56 216+' },
      { title: 'E-mail',         line: 'contact@khotoua.com' },
      { title: 'Réseaux sociaux' },
    ],
    socialsAlt: {
      tiktok: 'TikTok',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedin: 'LinkedIn',
      youtube: 'YouTube',
    },
  },
  
  download: {
    titleAlt: "Téléchargez l'application maintenant",
    titleText: "Téléchargez L'application",
    description: 
    [
      'Offrez à votre enfant le compagnon idéal pour s’épanouir',
      'Son expérience éducative de manière ludique et passionnante',
    ],
    cta : "Téléchargez L'app",
  },

   footer: {
    title: 'Chaque réussite a une étape...',
    sectionsCol1: [
      { id: 'about', label: 'Á propos' },
      { id: 'content', label: 'Contenus éducatif' },
      { id: 'features', label: "Politique publique" },
    ],
    sectionsCol2: [
      { id: 'trust', label: 'Avis' },
      { id: 'contact', label: 'Caractéristiques d\'app' },
      { id: 'download', label: 'Nous-contact' },
    ],
    logoAlt: 'Logo Khotwa',
    orangeLineAlt: 'Ligne orange',
    productBy: 'Producteur exécutif:',
  },

  privacy: {
    title: 'Politique de Confidentialité',
    lastUpdated: 'Dernière mise à jour:',
    introduction: 'Chez Khotoua, nous nous engageons à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre application mobile.',
    sections: [
      {
        title: 'Informations que nous collectons',
        content: 'Nous collectons les informations que vous nous fournissez directement, notamment: le nom et les informations de profil (comme la photo de profil), les informations sur l\'appareil (comme l\'ID de l\'appareil, le système d\'exploitation et le réseau mobile), les données d\'utilisation (comme les fonctionnalités utilisées, le temps passé dans l\'app), et les données de diagnostic (comme les journaux d\'erreurs et les données de performance).',
      },
      {
        title: 'Comment nous utilisons vos informations',
        content: 'Nous utilisons les informations que nous collectons pour: fournir et améliorer nos services, personnaliser votre expérience, communiquer avec vous sur les mises à jour et nouvelles fonctionnalités, analyser les modèles d\'utilisation pour améliorer les performances de l\'application, et assurer la sécurité et prévenir la fraude.',
      },
      {
        title: 'Partage et divulgation des données',
        content: 'Nous ne vendons pas vos informations personnelles. Nous pouvons partager des informations avec: les fournisseurs de services qui nous aident à exploiter l\'application, les partenaires d\'analyse pour nous aider à comprendre l\'utilisation de l\'application, et les autorités légales lorsque requis par la loi.',
      },
      {
        title: 'Sécurité des données',
        content: 'Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles contre tout accès non autorisé, altération, divulgation ou destruction.',
      },
      {
        title: 'Confidentialité des enfants',
        content: 'Notre application est conçue pour les enfants de 5 à 12 ans. Nous collectons des informations personnelles minimales sur les enfants, avec le consentement parental. Les parents peuvent examiner, mettre à jour ou supprimer les informations de leur enfant à tout moment.',
      },
      {
        title: 'Vos droits',
        content: 'Vous avez le droit de: accéder à vos informations personnelles, demander la correction des données inexactes, demander la suppression de vos données, vous opposer au traitement de vos données, et exporter vos données dans un format portable.',
      },
      {
        title: 'Suppression de compte',
        content: 'Pour demander la suppression de votre compte et de vos données personnelles, veuillez envoyer un e-mail à contact@khotoua.com avec l\'adresse e-mail de votre compte. Nous traiterons votre demande dans les 30 jours.',
      },
      {
        title: 'Modifications de cette politique',
        content: 'Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous vous notifierons de tout changement important en публиuant la nouvelle politique sur cette page et en mettant à jour la date de "Dernière mise à jour".',
      },
      {
        title: 'Contactez-nous',
        content: 'Si vous avez des questions sur cette politique de confidentialité, veuillez nous contacter à contact@khotoua.com.',
      },
    ],
  },

};

export default fr;
